import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import App from './App';
import { ToastProvider } from './components/toast';
import { createQueryClient } from './queryClient';
import './index.css';

/** VITE_MOCK=true serves the whole /bo-api contract from the browser (no API needed). */
async function enableMocks(): Promise<void> {
  if (import.meta.env.VITE_MOCK !== 'true') return;
  try {
    const { worker } = await import('./mocks/browser');
    await worker.start({
      serviceWorker: { url: `${import.meta.env.BASE_URL}mockServiceWorker.js` },
      onUnhandledRequest: 'bypass',
      quiet: true,
    });
  } catch (error) {
    // The app must still render if the service worker cannot be registered.
    console.error('[mock] service worker indisponible', error);
  }
}

function render(): void {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={createQueryClient()}>
        <BrowserRouter basename="/admin">
          <ToastProvider>
            <App />
          </ToastProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void enableMocks().finally(render);
